import { useMemo } from "react";
import branding from "../config/branding";

export const useBranding = () => {
  const APP_NAME = (import.meta.env.VITE_THEME as keyof typeof branding) || "goto";

  return useMemo(() => branding[APP_NAME] || branding.goto, [APP_NAME]);
};
